import { BigNumber } from 'ethers'

export interface IFutureValues {
  futureDeposited: BigNumber | null
  futureBorrowed: BigNumber | null
  futureAvailable: BigNumber | null
  futureLiquidationPrice: BigNumber | null
  futureLTV: BigNumber | null
}

export const NULL_FUTURE_VALUES = {
  futureDeposited: null,
  futureBorrowed: null,
  futureAvailable: null,
  futureLiquidationPrice: null,
  futureLTV: null,
}
